<template>
  <div class="ev-page-container ev-page-container--wide">
    <!-- edit department-modal -->
    <modal
      name="edit-department-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      draggable=".window-header"
    >
      <edit-department
        :selectedDepartment="selectedDepartment"
        :shifts="shifts"
        :saturdayShifts="saturdayShifts"
        :isSaveAndProceedButtonVisible="false"
        title="Uredi sektor"
        @saveAndCloseButtonClicked="editDepartmentClicked"
      />
    </modal>

    <!-- delete department-modal -->
    <modal
      name="delete-department-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <div class="ev-delete-modal">
        <div class="ev-delete-modal-header">
          <span class="ev-delete-icon">⚠️</span>
          <h2>Obriši sektor</h2>
        </div>
        <div class="ev-delete-modal-body">
          <p>Da li zaista želite da obrišete sektor</p>
          <span class="ev-delete-item-name">{{ selectedDepartment.name }}</span>
        </div>
        <div class="ev-delete-modal-actions">
          <button
            class="ev-btn ev-btn-cancel"
            @click="$modal.hide('delete-department-modal')"
          >
            Odustani
          </button>
          <button class="ev-btn ev-btn-danger" @click="deleteDepartmentClicked">
            <font-awesome-icon icon="trash-alt" />
            Obriši
          </button>
        </div>
      </div>
    </modal>

    <!-- add department-modal -->
    <modal
      name="add-department-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-department
        :selectedDepartment="selectedDepartment"
        :shifts="shifts"
        :saturdayShifts="saturdayShifts"
        :isSaveAndProceedButtonVisible="false"
        title="Dodaj sektor"
        @saveAndCloseButtonClicked="addDepartmentClicked"
      />
    </modal>

    <!-- Page Header -->
    <div class="ev-page-header">
      <h1 class="ev-page-title">
        <span class="ev-title-icon">🏢</span>
        Sektori
      </h1>
      <p class="ev-page-subtitle">Administracija sektora u preduzeću</p>
    </div>

    <!-- Table Section -->
    <div class="ev-table-section">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">📋</span>
          Lista sektora
        </h3>
        <span class="ev-table-count">{{ rows.length - 1 }} sektora</span>
      </div>
      <div class="ev-table-container">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true,
            searchFn: searchFunc,
            placeholder: 'Pretraži sektore...',
          }"
          @on-row-dblclick="onRowDoubleClick"
        >
          <template slot="table-row" slot-scope="props">
            <span
              v-if="props.column.field == 'before'"
              class="ev-action-buttons"
            >
              <!-- edit icon -->
              <button
                class="ev-action-btn ev-action-btn-edit"
                v-show="props.row.isnew === false"
                @click="editRow(props.row)"
                title="Uredi"
              >
                <font-awesome-icon icon="edit" />
              </button>
              <!-- delete icon -->
              <button
                class="ev-action-btn ev-action-btn-delete"
                v-show="props.row.isnew === false"
                @click="deleteRow(props.row)"
                title="Obriši"
              >
                <font-awesome-icon icon="trash-alt" />
              </button>
              <!-- add new row button -->
              <button
                class="ev-btn ev-btn-primary"
                v-show="props.row.isnew === true"
                @click="addRow(props.row)"
              >
                <font-awesome-icon icon="plus" />
                Dodaj novi sektor
              </button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import EditDepartment from "../parts/EditDepartment.vue";

export default {
  components: {
    VueGoodTable,
    EditDepartment,
  },
  name: "Departments",
  data() {
    return {
      errorMessage: "",
      successMessage: "",
      addDepartmentErrorMessage: "",
      selectedDepartment: {
        name: "nothing",
      },
      editModalName: "",
      columns: [
        {
          label: "R.Br.",
          field: "ordinal",
          type: "number",
          sortable: false,
        },
        {
          label: "Naziv sektora",
          field: "name",
          sortable: false,
        },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
      ],
      rows: [],
      shifts: [],
      saturdayShifts: [],
    };
  },
  computed: {},
  mounted() {
    this.getDepartments();
    this.getShifts();
    this.getSaturdayShifts();
  },
  methods: {
    searchFunc(row, col, cellValue, searchTerm) {
      if (typeof cellValue === "string" || cellValue instanceof String) {
        return cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (cellValue == null) {
        return true;
      }
    },
    getShifts() {
      UserService.getShifts().then((response) => {
        console.log(response);
        response.data.forEach((shift) => {
          this.shifts.push({
            id: shift.shiftId,
            name: shift.name,
          });
        });
      });
    },
    getSaturdayShifts() {
      UserService.GetSaturdayShifts().then((response) => {
        console.log("HIC #########$");
        console.log(response);
        response.data.forEach((shift) => {
          this.saturdayShifts.push({
            id: shift.saturdayshiftId,
            name: shift.note,
          });
        });
      });
    },
    getDepartments() {
      // get all departments with appropriate info
      UserService.getDepartments().then(
        (response) => {
          console.log(response);
          response.data.forEach((element) => {
            this.rows.push({
              id: element.departmentId,
              ordinal: element.ordinal,
              name: element.name,
              shiftId: element.shiftId,
              saturdayShiftId: element.saturdayShiftId,
              description: element.description,
              companyId: element.companyId,
              isnew: false,
            });
          });
          // add "add" row
          this.rows.push({
            id: null,
            ordinal: null,
            name: null,
            shiftId: null,
            saturdayShiftId: null,
            description: null,
            companyId: null,
            isnew: true,
          });
        },
        (error) => {
          this.errorMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    editRow(dep) {
      // console.log("HIC###");
      // console.log(dep);
      this.selectedDepartment = dep;
      this.editModalName = dep.name;
      this.$modal.show("edit-department-modal");
    },
    deleteRow(dep) {
      this.selectedDepartment = dep;
      this.editModalName = dep.name;
      this.$modal.show("delete-department-modal");
    },
    addRow(dep) {
      this.selectedDepartment = dep;
      this.editModalName = dep.name;
      this.$modal.show("add-department-modal");
    },
    onRowDoubleClick(params) {
      this.editRow(params.row);
    },
    editDepartmentClicked(dep) {
      console.log("dep");
      console.log(dep);
      let departmentToEdit = {
        name: dep.name,
        companyId: dep.companyId,
        departmentId: dep.id,
        shiftId: dep.shiftId,
        saturdayShiftId: dep.saturdayShiftId,
        description: dep.description,
        ordinal: dep.ordinal,
      };

      console.log("Hic22!!!");
      console.log(departmentToEdit);

      UserService.putDepartment(departmentToEdit).then(
        (response) => {
          console.log(response.data);
          // reload depts
          this.rows = [];
          this.getDepartments();
        },
        (error) => {
          this.errorMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );

      this.$modal.hide("edit-department-modal");
    },
    deleteDepartmentClicked() {
      let departmentToDelete = {
        name: this.selectedDepartment.name,
        companyId: this.selectedDepartment.companyId,
        departmentId: this.selectedDepartment.id,
        description: this.selectedDepartment.description,
      };

      // console.log("departmentToDelete");
      // console.log(departmentToDelete);

      UserService.deleteDepartment(departmentToDelete).then(
        (response) => {
          console.log(response.data);
          // reload depts
          this.rows = [];
          this.getDepartments();
        },
        (error) => {
          this.errorMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );

      this.$modal.hide("delete-department-modal");
    },
    addDepartmentClicked() {
      this.addDepartmentErrorMessage = "";
      // find max ordinal
      let maxOrdinal = Math.max.apply(
        Math,
        this.rows.map(function (r) {
          return r.ordinal;
        })
      );

      // create new department
      let newDepartment = {
        name: this.selectedDepartment.name,
        description: this.selectedDepartment.description,
        companyId: null,
        shiftId: this.selectedDepartment.shiftId,
        saturdayShiftId: this.selectedDepartment.saturdayShiftId,
        workingHoursId: null,
        ordinal: maxOrdinal + 1,
      };

      console.log("newDepartment");
      console.log(newDepartment);

      if (newDepartment.name !== null && newDepartment.name !== "") {
        // call axios
        UserService.postDepartment(newDepartment).then(
          (response) => {
            console.log("response");
            console.log(response);
            // reload ui
            this.rows = [];
            this.getDepartments();
          },
          (error) => {
            this.errorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        this.selectedDepartment.name = null;

        this.$modal.hide("add-department-modal");
      } else {
        this.addDepartmentErrorMessage = "Sektor mora imati ime";
      }
    },
  },
};
</script>

<style scoped>
/* Component-specific styles - all common styles are in common.css */

/* Legacy support */
.modal-header {
  margin-top: 0rem;
  margin-bottom: 1.5rem;
  background-color: #eff5fb;
}
</style>
